import React from 'react';
import { Button } from '../atoms/button';
import { ReportProblemTemplateProps } from '../../types/ReportProblem.types';
import { Label } from '../atoms/label';
import { Textarea } from '../atoms/textarea';
import { Card, CardHeader, CardContent, CardFooter, CardTitle } from '../atoms/card';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../atoms/select';

export default function ReportProblemTemplate(props: ReportProblemTemplateProps) {
  const {
    issueType,
    onIssueTypeChange,
    description,
    onDescriptionChange,
    error,
    isSubmitting,
    onSubmit,
    onCancel,
    maxChars = 2000,
  } = props;

  const chars = description ? description.length : 0;

  return (
    <div className="min-h-screen flex items-start justify-center py-12 bg-[transparent]">
      <div className="w-full max-w-[760px]">
        <h1 className="text-3xl font-semibold mb-6">Report a Problem</h1>

        <Card className="w-full shadow-lg rounded-2xl pt-6">
          <CardContent>
          <div className="mb-6">
            <Label className='font-medium text-sm'>What's the issue?</Label>
            <Select
              value={issueType ?? ''}
              onValueChange={(v) => onIssueTypeChange(v ? (v as any) : null)}
            >
              <SelectTrigger className="w-full rounded-xl" size="default">
                <SelectValue placeholder="Select..." />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="bug">Bug / Something not working</SelectItem>
                <SelectItem value="wrong_result">Wrong result</SelectItem>
                <SelectItem value="performance">Performance issue</SelectItem>
                <SelectItem value="ui">UI issue</SelectItem>
                <SelectItem value="other">Other</SelectItem>
              </SelectContent>
            </Select>
            {error ? (
              <p id="report-issue-error" className="text-red-600 text-sm mt-2">{error}</p>
            ) : null}
          </div>

          <div className="mb-6">
            <div className="flex items-center justify-between">
              <Label className='font-medium text-sm mb-0'>Describe the problem</Label>
              <span className="text-gray-500 font-medium text-xs">(Optional)</span>
            </div>
            <Textarea
              value={description ?? ''}
              onChange={(e) => onDescriptionChange(e.target.value)}
              placeholder="Explain the problem in detail"
              className="min-h-[160px] rounded-xl text-sm shadow-sm"
              maxLength={maxChars}
            />
            <div className="text-gray-500 font-medium text-xs mt-2 text-right">{chars}/{maxChars}</div>
          </div>
        </CardContent>

        <CardFooter className="justify-end gap-3">
          <Button variant="secondary-gray" size="sm" className="text-primary-600 hover:text-primary-800 hover:bg-primary-50" onClick={onCancel} disabled={isSubmitting}>Cancel</Button>
          <Button variant="primary" size="sm" onClick={onSubmit} disabled={isSubmitting} aria-busy={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send'}
          </Button>
        </CardFooter>
      </Card>
    </div>
    </div>
  );
}
